import AbstractEntity from './AbstractEntity';

class Yacht extends AbstractEntity {
  getFullTitle() {
    return `${this.entity.vendor} ${this.entity.model}`;
  }

  getCaptain() {
    if (!this.entity || !this.entity.user) {
      return '';
    }
    return `${this.entity.user.name.first} ${this.entity.user.name.last}`;
  }

  getCabinCount() {
    if (!this.entity || !this.entity.cabin) {
      return 0;
    }
    return this.entity.cabin;
  }

  getPlacesCount() {
    if (!this.entity || !this.entity.place) {
      return 0;
    }
    return this.entity.place;
  }

  getUserSlug() {
    return this.entity.user.slug;
  }
}

export default Yacht;
